import React from 'react';

import {
  Header,
  Container,
  Title,
  Grid,
  Row,
  Col,
  MainText,
  Link,
} from './Fraud.style';
import {SubHeaderCenter} from '../../styles/generic.style';

function SupplierNotification() {
  return (
    <Container>
      <Title>SUPPLIER NOTICE</Title>
      <SubHeaderCenter>MAY 2026</SubHeaderCenter>
      <Grid>
        <Row>
          <Col size={1}>
            <Header>To Future And Existing Suppliers</Header>
            <MainText>Dear Supplier,</MainText>
            <MainText>
              We would like to remind you that our correct company name, which
              is also our trading name, is <strong>JJ Food Service Limited.</strong> Our
              registered and head office address is:
            </MainText>
            <MainText>
              <strong>7 Solar Way<br />
              Innova Park<br />
              Enfield<br />
              Middlesex<br />
              EN3 7XY</strong>
            </MainText>
            <MainText>
              Please note that we will only accept deliveries where the correct
              company name is clearly stated, together with the accurate
              delivery address of the relevant branch and a valid{' '}
              <strong>purchase order (PO) number.</strong>
            </MainText>
            <MainText>
              Furthermore, please be advised that all purchase orders are issued
              electronically. We do not place orders via telephone, nor do we
              arrange collections unless formal written confirmation has been
              provided by your usual JJ Food Service contact.
            </MainText>
            <MainText>
              If you are using a third-party haulier, it is your responsibility
              to ensure that all relevant and accurate delivery information is
              communicated, including our purchase order number. All CMR
              documentation must be fully completed and accurate. In addition,
              delivery notes and invoices must clearly reference the CMR number
              and container number, where applicable.
            </MainText>
            <MainText>
              We reserve the right to refuse any delivery that is not
              accompanied by the correct documentation, including our company
              name, delivery address, and purchase order number. Please be aware
              that failure to provide accurate documentation may result in
              delays in invoice processing and subsequent payment.
            </MainText>
            <MainText>
              We kindly request that you update your records accordingly and
              ensure that all relevant departments, as well as any appointed
              hauliers, are informed of these requirements. Failure to comply
              may result in loss of goods, for which JJ Food Service Limited
              cannot accept liability.
            </MainText>
            <MainText bold={true}>
              Please refer to the branch list at the link below:
            </MainText>
            <Link
              href={'https://www.jjfoodservice.com/branchLocator/'}
              target="_blank"
              rel="noopener noreferrer"
            >
              Link for the Branch List.
            </Link>
            <MainText>
              No other location should be considered an authorised delivery
              point for JJ Food Service Limited.
            </MainText>
            <br />
            <MainText>
              Thank you for your cooperation. We look forward to maintaining
              and developing a successful long-term business relationship with
              you.
            </MainText>
          </Col>
        </Row>
      </Grid>
    </Container>
  );
}

export default SupplierNotification;
